import { useState, useEffect } from 'react';
import { useToken } from '../../hooks/useToken';
import { useNavigate } from 'react-router-dom';
import { Button, Dialog, DialogContent, DialogActions, DialogTitle, DialogContentText } from '@mui/material';
import jwt_decode from "jwt-decode";

const InactivityLogout = ({ children }) => {
  const [isLogged, setIsLoggedOut] = useState(true);
  const [token, { saveToken }] = useToken();
  const [openModal, setOpenModal] = useState(false);
  const logoutWarningTime = 600000;
  const history = useNavigate();

  const redirectToLogin = () => {
    saveToken(null);
    history('/login');
  };

  const checkInactivity = () => {
    const userToken = sessionStorage.getItem('token');
    const decodedToken = jwt_decode(userToken);
    const expireTime = decodedToken.exp;
    const expireTimeInMilliseconds = expireTime * 1000;
    if (expireTimeInMilliseconds < Date.now()) {
      setOpenModal(true);
      setIsLoggedOut(false);
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      checkInactivity();
    }, logoutWarningTime);
    return () => clearInterval(interval)
  }, []);

  const handleLogout = () => {
    setIsLoggedOut(true);
    redirectToLogin();
  };


  if (!isLogged) {
    return (
      <Dialog open={openModal} aria-labelledby="dialog-title" maxWidth="sm" disableBackdropClick>
        <DialogTitle id="dialog-title">Sessão expirada!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Gentileza efetuar o login novamente para continuar utilizando o sistema com segurança!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" size="small" onClick={handleLogout}>
            Fazer login
          </Button>
        </DialogActions>
      </Dialog>

    );
  }

  return children;
};

export default InactivityLogout;

